import { render, staticRenderFns } from "./MapFrom.vue?vue&type=template&id=bb80f5c6"
import script from "./MapFrom.vue?vue&type=script&lang=js"
export * from "./MapFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports